import { SupersetClient } from '@aibi-ui/core';

// 获取图表列表
export const getChartListAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/chart/', searchParams });

// 查询图表是否收藏
export const getChatIsFavoriteAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/chart/favorite_status/',
    searchParams,
  });

// 收藏图表
export const postChartFavoriteAPI = id =>
  SupersetClient.post({ endpoint: `/api/v1/chart/${id}/favorites/` });

// 取消收藏图表
export const deleteChartFavoriteAPI = id =>
  SupersetClient.delete({ endpoint: `/api/v1/chart/${id}/favorites/` });

/** 分享图表 */
export const postShareMyChartAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/my_chart/share', jsonPayload });

/** 编辑分享图表 */
export const putShareMyChartAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/my_chart/share', jsonPayload });

/** 根据分享id获取分享详情 */
export const getMyChartShareAPI = shareId =>
  SupersetClient.get({ endpoint: `/api/v1/my_chart/share/${shareId}` });

/** 校外公开的图表信息 */
export const getMyChartPublicExploreAPI = shareId =>
  SupersetClient.get({
    endpoint: `/api/v1/my_chart/public/explore/${shareId}`,
    ignoreUnauthorized: true,
  });

/** 查看校内/部分公开的图表信息 */
export const getMyChartPrivateExploreAPI = shareId =>
  SupersetClient.get({
    endpoint: `/api/v1/my_chart/private/explore/${shareId}`,
  });

/** 校外公开获取图表数据 */
export const getChartDataPublicAPI = async ({ searchParams, jsonPayload }) =>
  SupersetClient.post({
    endpoint: '/api/v1/chart/data/public',
    searchParams,
    jsonPayload,
    ignoreUnauthorized: true,
  });

/**
 *  获取图表数据
 * @param {Object} searchParams
 * @param {number} searchParams.datasource_id
 * @param {string} searchParams.datasource_type
 * @returns
 */
export const getExploreAPI = searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/explore/', searchParams });
